import script from "./ExcerptMultiSelectMiniModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcerptMultiSelectMiniModal.vue?vue&type=script&setup=true&lang=js"

import "./ExcerptMultiSelectMiniModal.vue?vue&type=style&index=0&id=605ef900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-605ef900"]])

export default __exports__